import sdkProvider from "../../../../client/sdkProvider";
import { setLoyaltyTier } from ".";
import logger from "../../../../lib/logger";

const loadLoyaltyCustomerTierId = () => async dispatch => {
  try {
    const identitySdk = await sdkProvider("identity");
    const isAuthenticated = await identitySdk.customer.isAuthenticated();
    if (!isAuthenticated) {
      dispatch(setLoyaltyTier(null));

      return;
    }

    const loyaltySdk = await sdkProvider("loyalty");
    const customerTierId = await loyaltySdk.getCustomerTierId();
    dispatch(setLoyaltyTier(customerTierId));
  } catch (error) {
    if (error.name !== "LoyaltyNotSupportedError") {
      error.message = `loadLoyaltyCustomerTierId failed with error: ${error.message}`;
      logger.error(error);
    }
  }
};

export default loadLoyaltyCustomerTierId;
